import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  titleClass: {
    fontFamily: 'Roboto Condensed',
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightLight,
    textAlign: 'center',
    width: '100%',
  },
}))
